import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button } from 'components/button'
import { setModal } from 'slices/modal'
import { setDrawer } from 'slices/drawer'
import { STATICS } from 'statics'
import { DRAWER_KEY, MODAL_KEYS } from 'app-constants'
import './style.scss'

export function Objections() {
  const dispatch = useDispatch()
  const { contractObjection } = useSelector(({ contract: { objection } }) => ({
    contractObjection: objection,
  }))

  function handleClick() {
    dispatch(setModal({ key: MODAL_KEYS.NONE }))
    dispatch(setDrawer(DRAWER_KEY.OBJECTIONS))
  }

  function renderObjection() {
    return <span className='protocol'>Protocolo N.° {contractObjection.ticketId}</span>
  }

  return (
    <div className='container-objections-modal'>
      <STATICS.EXCLAMATION_MARK />
      <span className='title'>Contestação</span>
      <div className='container-info'>
        <span className='text'>Acompanhe aqui o status das suas contestações</span>
        {renderObjection()}
      </div>
      <div className='container-button'>
        <Button className='button' color='primary' onClick={handleClick}>
          Acompanhar solicitação &gt;
        </Button>
      </div>
    </div>
  )
}
